import React, { createContext, useContext, useState } from 'react';

const FriendsContext = createContext({});

export function FriendsProvider({ children }) {
  const [friendsCount, setFriendsCount] = useState(0);

  const updateFriendsCount = (count) => {
    setFriendsCount(count);
  };

  return (
    <FriendsContext.Provider value={{ friendsCount, updateFriendsCount }}>
      {children}
    </FriendsContext.Provider>
  );
}

export function useFriends() {
  const context = useContext(FriendsContext);
  if (!context) {
    throw new Error('useFriends must be used within a FriendsProvider');
  }
  return context;
}
